import { Dictionary } from 'lodash'

/**
 * Turns an array of objects that have an property of the key param into a dictionary
 * @param key The property to the object to use and the dictionary key (MUST be unique)
 * @param array Array of objects that have a property of the key param
 * @returns dictionary of the objects keyed on the key param
 */
export function arrayToDictionary<T>(key: string, array: T[]): Dictionary<T> {
  const dict: Dictionary<T> = {}

  array.forEach((item: T) => {
    if (!item[key]) {
      throw new Error(`T[key] cannot be undefined`)
    }

    dict[item[key]] = item
  })

  return dict
}
